import { styled } from "@mui/material/styles";
import Breadcrumbs, { BreadcrumbsProps } from "@mui/material/Breadcrumbs";

export const StyledBreadcrumbs = styled(Breadcrumbs)<BreadcrumbsProps>(() => ({
  "& .MuiBreadcrumbs-li": {
    padding: "4px 8px",
    color: "#475467",
  },

  "& .MuiBreadcrumbs-separator": {
    color: "#D0D5DD",
  },

  "& .MuiBreadcrumbs-li:last-of-type": {
    color: "#A61C14",
    backgroundColor: "#A61C141A",
    borderRadius: "6px",
  },
}));
